import { allSendersIdsSelector } from '../selectors/senders-selectors';
import {
    FETCH_SENDER_REQUEST,
    FETCH_SENDER_SUCCESS,
    FETCH_SENDER_FAILURE,
} from './types/senders-action-types';
import MimirService from '../services/mimir-service';

const sendersRequest = ( ) => {
    return {
        type: FETCH_SENDER_REQUEST,
    };
};

const sendersSuccess = ( response ) =>  {
    return {
        data: response,
        type: FETCH_SENDER_SUCCESS,
    };
};

const sendersError = ( params ) =>  {
    return {
        params,
        type: FETCH_SENDER_FAILURE,
    };
};


const checkForExistingSender = ( senderId, state ) => {
    const allSenderIds = allSendersIdsSelector( state );

    return allSenderIds.includes( senderId );
};

export function fetchSender( senderId ){
    return ( dispatch, getState, { DATA_API } ) => {
        const state = getState();

        if( checkForExistingSender( senderId, state ) ){
            return Promise.resolve();
        }

        const api = new MimirService( DATA_API );

        dispatch( sendersRequest() );

        return api.getSender( senderId ).then(
            ( response ) => dispatch( sendersSuccess( response ) ),
            ( error ) => dispatch( sendersError( error ) )
        );
    };
}
